// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.settings_dashboard__FHk5D {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.settings_dashboardContain__U2OSm {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.settings_bodythemedark__CUjRX .settings_dashboardContain__U2OSm,
.settings_bodythemedark__CUjRX .settings_dashboard__FHk5D,
.settings_bodythemedark__CUjRX .settings_cont2__VlNwH {
  background-Color: #0f1824;
}

.settings_top_header__ff-Zj .settings_top_header_inner__CdYKG {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.settings_cont2__VlNwH {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.settings_subLink__DFs3N svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.settings_cst_vendr__igBRt input {
  min-height: 35px !important;
}

.settings_cst_vendr__igBRt .settings_form-control__qWwCC {
  background-color: #f5f6fa;
  border: none;
}

.settings_footer__P4xQU {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.settings_bodythemelight__daVLj {
  background-color: #fff;
  padding-top: 90px;
}

.settings_bodythemedark__CUjRX {
  background-color: #132337;
  padding-top: 90px;
}

.settings_bodythemeNew__YiMMO {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.settings_headerthemelight__-DecU {
  background-color: #fff;
}

.settings_headerthemedark__VXMQL {
  background-color: #132337;
}

.settings_top_header__ff-Zj {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.settings_menuthemelight__xa936 {
  background-color: #f5f6fa;
}

.settings_menuthemedark__0RlW9 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.settings_menulinklight__2ukHf span {
  color: #666666 !important;
}

.settings_menulinklight__2ukHf a {
  color: #CBCBCB !important;
}

.settings_menulinklight__2ukHf:hover span,
.settings_menulinklight__2ukHf:hover a {
  color: #fff !important;
}

.settings_menulinkdarkSelected__qg5eL {
  background-color: #1c2e45;
  color: #3b82f6;
}

.settings_menuthemelight__xa936 .settings_menulinklightSelected__-Sh8x {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.settings_menulinkdark__ZEp0Q {
  color: #92afd3 !important;
}

.settings_menulinklight__2ukHf:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.settings_menulinklight__2ukHf .settings_sub_arrow__fGoo- svg path {
  stroke: #CBCBCB !important;
}

.settings_menulinklight__2ukHf:hover .settings_sub_arrow__fGoo- svg path {
  stroke: #fff !important;
}

.settings_menulinkdark__ZEp0Q .settings_sub_arrow__fGoo- svg path {
  stroke: #92afd3 !important;
}

.settings_menulinkdark__ZEp0Q:hover .settings_sub_arrow__fGoo- svg path {
  stroke: #fff !important;
}

.settings_menulinklight__2ukHf:hover svg path,
.settings_menulinklightSelected__-Sh8x svg path {
  fill: #fff !important;
}

.settings_menulinkdark__ZEp0Q:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.settings_headinglight__doSQ0 {
  color: #60677e;
}

.settings_headingdark__n\\+TEX {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.settings_searchboxlight__Exe8H {
  background-color: #fff;
  border: none;
}

.settings_searchboxdark__0LYGy {
  background-color: #132337;
  color: #fff;
  border: none;
}

.settings_searchboxdark__0LYGy::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.settings_tableheadlight__I2wDM {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.settings_tableheadlight__I2wDM th {
  color: #fff;
}

thead .settings_tableheadlight__I2wDM th:first-child,
thead .settings_tableheaddark__BAzcZ th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .settings_tableheadlight__I2wDM th:last-child,
thead .settings_tableheaddark__BAzcZ th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.settings_table__wcs2I.settings_table-borderless__XlVcO {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.settings_tableheaddark__BAzcZ {
  background-color: #132337;
  color: #fff;
}

.settings_table-borderless__XlVcO tr:nth-child(even) {
  background-color: #F9FAFB;
}

.settings_table-borderless__XlVcO .settings_left-section__Mo-jA {
  padding-top: 10px;
}

.settings_tablebodylight__F8haX td,
.settings_tablebodydark__qeszF td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.settings_tablebodylight__F8haX {
  background-color: #fff;
}
.settings_tablebodylight__F8haX:hover {
  background-color: #fff;
  cursor: auto;
}
.settings_tablebodylight__F8haX p {
  line-height: 24px;
}

.settings_tablebodydark__qeszF {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.settings_tablebodydark__qeszF:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.settings_paginationlight__BGULt {
  color: #60677e !important;
  font-size: 13px !important;
}

.settings_paginationdark__Hz6pf {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.settings_formthemelight__HnEnB {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.settings_formthemedark__ffb0i {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.settings_formthemedark__ffb0i ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.settings_viewformlight__AIIgi {
  background-color: #f3f6f9;
}

.settings_permissionboxlight__UvL2i {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.settings_permissionboxdark__qBhr4 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.settings_errormsgclr__QmeiF {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.settings_graphclrlight__rlfpD {
  background-color: #fff;
}

.settings_graphclrdark__tho2P {
  background-color: #132337;
}

/* 
Counter theme
*/
#settings_card1bglight__mR3L5 {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#settings_card1bgdark__HX9ph {
  background: #392f28;
}

#settings_card2bglight__\\+y-JH {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#settings_card2bgdark__Kfhe7 {
  background: #1c3238;
}

#settings_card3bglight__XbcQO {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#settings_card3bgdark__ILj6B {
  background: #3a2434;
}

#settings_card4bglight__fGD5L {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#settings_card4bgdark__0tK9O {
  background: #2f264f;
}

#settings_card1bgdark__HX9ph a,
#settings_card1bgdark__HX9ph p,
#settings_card2bgdark__Kfhe7 a,
#settings_card2bgdark__Kfhe7 p,
#settings_card3bgdark__ILj6B a,
#settings_card3bgdark__ILj6B p,
#settings_card4bgdark__0tK9O a,
#settings_card4bgdark__0tK9O p {
  color: #fff;
}

/* 
Action button theme
*/
.settings_actionbtnlight__4Sk0H {
  color: rgba(70, 71, 91, 0.8705882353);
}

.settings_actionbtndark__La-Jh {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.settings_profiledropdownlight__NbgyO {
  background-color: #fff;
}

.settings_profiledropdowndark__D0QpQ {
  background-color: #151521;
}

.settings_settingsection__xu5at #settings_addform__Dk7Mj.settings_formthemedark__ffb0i .settings_savebtn__yNpbe {
  background-color: #3b82f6;
  color: #fff;
}

#settings_addform__Dk7Mj.settings_formthemedark__ffb0i .settings_savebtn__yNpbe {
  background-color: #3b82f6;
  color: #fff;
}

.settings_profile_conatiner__rzq8z {
  border-radius: 5px !important;
}

.settings_bodythemedark__CUjRX .settings_ag-theme-alpine__wCbtM .settings_ag-row__xu1As {
  background: #000 !important;
}

.settings_bodythemedark__CUjRX .settings_formbtn__mm3Wt {
  background-color: #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_formbtn__mm3Wt:hover {
  background-color: #2563eb;
}

.settings_bodythemedark__CUjRX .settings_resetbtn__FRARY {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_resetbtn__FRARY:hover {
  background-color: #3b82f6;
}

.settings_headingdark__n\\+TEX span {
  background-color: #132337;
}

.settings_resetbtn__FRARY {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.settings_resetbtn__FRARY:hover,
.settings_resetbtn__FRARY:active,
.settings_resetbtn__FRARY:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.settings_addBtn__eaiUM {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.settings_addDltBtn__ArGCa {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.settings_addbtnlight__gWrRV {
  background-color: #38A169;
}

.settings_addbtndark__NmlKJ {
  background-color: #3b82f6;
}

.settings_addbtndark__NmlKJ:hover {
  background-color: #2563eb;
}

.settings_formthemedark__ffb0i label {
  color: #92afd3;
}

.settings_addBtn__eaiUM svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.settings_addBtn__eaiUM:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.settings_cust_addBtn__OhiGl.settings_addBtn__eaiUM svg {
  top: 2px;
}

.settings_deleteBtn__bL4Ju {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.settings_deleteBtn__bL4Ju {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.settings_deleteBtn__bL4Ju:active,
.settings_deleteBtn__bL4Ju:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.settings_deleteBtn__bL4Ju svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.settings_deleteBtn__bL4Ju:hover,
.settings_deleteBtn__bL4Ju:active,
.settings_deleteBtn__bL4Ju:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.settings_confirmBtn__Wnp0z {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.settings_confirmBtn__Wnp0z:hover,
.settings_confirmBtn__Wnp0z:active,
.settings_confirmBtn__Wnp0z:focus {
  background-color: #0f1824 !important;
}

.settings_confirmBtn__Wnp0z svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.settings_delPopContainer__FCjdY .settings_modal-body__MJgKL {
  padding: 35px;
  text-align: center;
}

.settings_delPopContainer__FCjdY .settings_delet_icon__uP6T3 {
  margin-bottom: 11px;
}

.settings_delPopContainer__FCjdY p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.settings_arrowback__qnVSX svg {
  fill: #000;
}

.settings_bodythemedark__CUjRX .settings_arrowback__qnVSX {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_arrowback__qnVSX svg {
  fill: #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_drpdwn_btn__PsPxB {
  background-color: #132337;
}

.settings_bodythemedark__CUjRX .settings_empname__6QldI {
  color: #92afd3 !important;
}

.settings_bodythemedark__CUjRX .settings_navitemli__4IC51 a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingsgeneral__0GBoO,
.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingslinks__vcT1Z:hover {
  background-color: #3b82f6;
  color: #fff;
}

.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingslinks__vcT1Z {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV {
  background-color: #1c2e45;
  color: #fff;
}

.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV ul li a,
.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV .settings_dropdown_item__Ioitd,
.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV .settings_dropdown_item__Ioitd h5 {
  color: #fff;
}

.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV ul li a:hover,
.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV .settings_dropdown_item__Ioitd:hover {
  background-color: #132337;
  color: #fff;
}

.settings_dropdown_item__Ioitd:active {
  background-color: #F5F6FA;
}

.settings_profile_arrrow_dwn__\\+vDFh {
  stroke: #132337;
}

.settings_headerthemedark__VXMQL .settings_profile_arrrow_dwn__\\+vDFh {
  stroke: #fff;
}

.settings_dateinputbox1__enon- input,
.settings_dateinputbox1__enon- span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.settings_delPopContainer__FCjdY .settings_modal-content__WgMKL {
  border-radius: 10px;
  min-width: 399px;
}

.settings_larg_model__xIt3W .settings_modal-dialog__6cI4N {
  max-width: 100% !important;
}

.settings_larg_model__xIt3W .settings_modal-content__WgMKL {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.settings_larg_model__xIt3W .settings_modal-header__qqmqs {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .settings_btn-primary__3ygSu:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.settings_form-select__qBlVU {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .settings_CustomTable_tableheadlight__HuHZw__gfJuU th:first-child,
thead .settings_CustomTable_tableheaddark__nwqb4__U\\+iwe th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .settings_tableheadlight__I2wDM th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .settings_dashboard__FHk5D {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .settings_cont2__VlNwH {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .settings_sectionright__lAAyc {
    float: unset !important;
  }
  .settings_dashboard__FHk5D {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .settings_cont2__VlNwH {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .settings_bodythemelight__daVLj,
.settings_bodythemedark__CUjRX {
    padding-top: 110px;
  }
  .settings_delPopContainer__FCjdY .settings_modal-content__WgMKL {
    min-width: 100%;
  }
  .settings_delPopContainer__FCjdY .settings_modal-body__MJgKL {
    padding: 15px;
  }
  .settings_larg_model__xIt3W .settings_modal-content__WgMKL {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .settings_exer_modal_contain__Yk2sS .settings_modal-dialog__6cI4N {
    max-width: 1055px;
  }
  .settings_delPopContainer__FCjdY .settings_modal-dialog__6cI4N {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.settings_active_show_outer__R5yTq h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .settings_active_show_outer__R5yTq h2 {
    margin-top: 15px;
  }
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn {
  width: 100%;
  display: block;
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_img__N4X0j {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_img__N4X0j {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_img__N4X0j img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_cnt__ihkKs {
  width: 100%;
  display: block;
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_cnt__ihkKs svg {
  flex-shrink: 0;
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_cnt__ihkKs .settings_act_box_bdg__eX64N {
  width: 100%;
  margin-bottom: 12px;
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_cnt__ihkKs .settings_act_box_bdg__eX64N span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_cnt__ihkKs .settings_act_box_bdg__eX64N .settings_sold__X86iS {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_cnt__ihkKs h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_cnt__ihkKs p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_cnt__ihkKs p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.settings_active_show_outer__R5yTq .settings_active_show_inner__Zj-Pn .settings_act_box_cnt__ihkKs p .settings_timezone_code_pill__1xsNj {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#settings_attent_details_row1__VXHV7 {
  margin-bottom: 0 !important;
}

.settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_l__Z3vcp img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw {
  flex: 1 1;
}
.settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw .settings_attent_details_row__DTIoo {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw .settings_attent_details_row__DTIoo {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw .settings_attent_details_row__DTIoo .settings_attent_details_row_box__8SFJs {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw .settings_attent_details_row__DTIoo .settings_attent_details_row_box__8SFJs {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw .settings_attent_details_row__DTIoo .settings_attent_details_row_box__8SFJs {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw .settings_attent_details_row__DTIoo .settings_attent_details_row_box__8SFJs p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw .settings_attent_details_row__DTIoo .settings_attent_details_row_box__8SFJs h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw .settings_attent_details_row_last__PjSGB {
  margin-bottom: 0px !important;
}
.settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw .settings_attent_details_row_last__PjSGB.settings_interesting_fact__avjXm {
  padding-top: 30px;
}
.settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw .settings_attent_details_row_last__PjSGB.settings_interesting_fact__avjXm .settings_attent_details_row_box__8SFJs {
  width: 100%;
}
.settings_attent_details__Xkm58 .settings_attent_details_inner__6bnjc .settings_attent_details_inner_r__L4iMw .settings_attent_details_row_last__PjSGB.settings_interesting_fact__avjXm .settings_attent_details_row_box__8SFJs h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.settings_showbox_sec__BE8je {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .settings_showbox_sec__BE8je {
    justify-content: center;
  }
}

.settings_show_box_main__OAgao {
  margin: 10px 0px;
}
.settings_show_box_main__OAgao .settings_show_box__fMbHW {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .settings_show_box_main__OAgao .settings_show_box__fMbHW {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .settings_show_box_main__OAgao .settings_show_box__fMbHW {
    min-height: 500px;
    width: 200px !important;
  }
}
.settings_show_box_main__OAgao .settings_show_box__fMbHW img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .settings_show_box_main__OAgao .settings_show_box__fMbHW img {
    max-height: 300px !important;
  }
}
.settings_show_box_main__OAgao .settings_show_box__fMbHW:last-child {
  margin-right: 0px !important;
}
.settings_show_box_main__OAgao .settings_no_show_box__SKKRO {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .settings_show_box_main__OAgao .settings_no_show_box__SKKRO {
    width: 250px !important;
  }
}
.settings_show_box_main__OAgao .settings_no_show_box__SKKRO img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .settings_show_box_main__OAgao .settings_no_show_box__SKKRO img {
    max-height: 350px !important;
  }
}
.settings_show_box_main__OAgao .settings_no_show_box__SKKRO h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .settings_show_box_main__OAgao .settings_no_show_box__SKKRO h6 {
    font-size: 20px;
  }
}

.settings_attent_flex__DH2zZ {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.settings_attent_flex__DH2zZ h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

#settings_addform__Dk7Mj {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
  padding-bottom: 40px;
  border-radius: 5px;
}
#settings_addform__Dk7Mj #settings_addheading__8sSM1 {
  font-size: 18px;
}
#settings_addform__Dk7Mj .settings_formarea__QYqBI {
  margin-top: 80px;
}
#settings_addform__Dk7Mj .settings_inputbox__7agbd {
  padding: 10px;
  width: 100%;
  color: #1d1d1d;
  font-size: 14px;
}
#settings_addform__Dk7Mj .settings_inputbox1__5RkFm {
  padding: 6px;
  border: none;
  border-radius: 3px;
  width: 100%;
  background-color: #0f1824;
  color: #fff;
}
#settings_addform__Dk7Mj .settings_eyeicon__dQMCd {
  margin-left: -30px;
  cursor: pointer;
}
#settings_addform__Dk7Mj .settings_savebtn__yNpbe {
  border: none;
  border-radius: 5px;
  background-color: #131F43;
  padding: 8px 12px;
  color: #fff;
  font-size: 14px;
  float: unset;
}
#settings_addform__Dk7Mj .settings_backbtn__O1vJn {
  background-color: rgba(37, 105, 109, 0.864);
  color: white;
  border: none;
  width: 100px;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-right: 10px;
}

/* Notification preferences */
.settings_preferencesCard__o0f6B {
  width: 100%;
  border-radius: 8px;
  margin-top: 32px;
  padding: 24px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.settings_preferencesTitle__z3tfr {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #1f2937;
}

.settings_preferencesLoading__FPBcP {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;
}

.settings_profileLoadingContainer__MUlKI {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.settings_suspenseFallback__hze99 {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
}

.settings_loading__i\\+1Zh {
  text-align: center;
  color: #4b5563;
  font-size: 16px;
  font-weight: 400;
  font-family: "Lufga", "Inter", sans-serif;
  margin: 0;
}

.settings_preferencesList__iGHhx {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.settings_preferenceRow__ENgJt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
}
.settings_preferenceRow__ENgJt:last-child {
  border-bottom: none;
}

.settings_preferenceLabel__69At4 {
  font-size: 14px;
  color: #374151;
}

.settings_manageBtn__60Iwj {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  color: #CD47F3;
  background: #fff;
  border: 1.5px solid #CD47F3;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease;
}
.settings_manageBtn__60Iwj:hover {
  background: #f9f0fe;
  border-color: #b83ad9;
  color: #b83ad9;
}
.settings_manageBtn__60Iwj:focus-visible {
  outline: 2px solid #CD47F3;
  outline-offset: 2px;
}

.settings_toggle__CB5ik {
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  border: none;
  background: #d1d5db;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
}
.settings_toggle__CB5ik:focus {
  outline: 2px solid #131F43;
  outline-offset: 2px;
}
.settings_toggle__CB5ik:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.settings_toggleOn__8Pi8- {
  background: #131F43;
}

.settings_toggleThumb__5HZSd {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}

.settings_toggleOn__8Pi8- .settings_toggleThumb__5HZSd {
  transform: translateX(20px);
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/settings/settings.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ACvEF;;AD0EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACvEF;;AD0EA;;;EAGE,yBApEoB;ACHtB;;AD0EA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACvEF;;AD0EA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ACrEF;;AD2EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACxEF;;AD6EA;EACE,2BAAA;AC1EF;;AD6EA;EACE,yBAAA;EACA,YAAA;AC1EF;;AD8EA;EACE,YAAA;AC3EF;;AD8EA;EACE,sBA9GY;ACmCd;;AD8EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC3EF;;AD8EA;EACE,yBArIgB;EAsIhB,iBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,sBAtIY;AC2Dd;;AD8EA;EACE,yBArJgB;AC0ElB;;AD8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBA1KgB;AC+FlB;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;EAEE,sBAAA;AC3EF;;AD8EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AC4HpB;;AD8EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;;EAEE,qBAAA;AC3EF;;AD8EA;EACE,yBArOsB;EAsOtB,WA7NY;ACkJd;;AD8EA;;CAAA;AAGA;EACE,cAjOe;ACsJjB;;AD8EA;EACE,cArOe;AC0JjB;;AD8EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AC3EF;;AD8EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AC3EF;;AD8EA;EACE,cAvPe;AC4KjB;;AD8EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AC3EF;;AD8EA;EACE,WAtQY;AC2Ld;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,oCAAA;EACA,gCAAA;AC3EF;;AD8EA;EACE,yBAzRkB;EA0RlB,WAlSY;ACuNd;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,iBAAA;AC3EF;;AD8EA;;EAEE,+BAAA;EACA,iBAAA;AC3EF;;AD8EA;EACE,sBApTY;ACyOd;AD6EE;EACE,sBAvTU;EAwTV,YAAA;AC3EJ;AD6EE;EACA,iBAAA;AC3EF;;ADgFA;EACE,0CAAA;EACA,cA/Te;ACkPjB;AD+EE;EACE,yCAAA;EACA,eAAA;AC7EJ;;ADiFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AC9EF;;ADiFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AC9EF;ADgFE;EACE,cAnWa;ACqRjB;;ADmFA;;CAAA;AAGA;EACE,yBAlXgB;ACkSlB;;ADmFA;EACE,yBAAA;EACA,yBAAA;AChFF;;ADmFA;EACE,yBAlYoB;EAmYpB,yBAAA;AChFF;;ADmFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFF;;ADmFA;;CAAA;AAGA;EACE,sBAtYY;ACsTd;;ADmFA;EACE,yBAlYkB;ACkTpB;;ADoFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ACkUd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA5ZY;AC2Ud;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBAraY;ACoVd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA9aY;AC6Vd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;;;;;;;;EAQE,WA7bY;AC4Wd;;ADoFA;;CAAA;AAGA;EACE,qCAAA;ACjFF;;ADoFA;EACE,cArce;ACoXjB;;ADqFA;;CAAA;AAGA;EACE,sBAAA;AClFF;;ADqFA;EACE,yBAAA;AClFF;;ADqFA;EACE,yBAzekB;EA0elB,WAzdY;ACuYd;;ADqFA;EACE,yBA9ekB;EA+elB,WA9dY;AC4Yd;;ADqFA;EACE,6BAAA;AClFF;;ADqFA;EACE,2BAAA;AClFF;;ADqFA;EACE,yBA3fkB;ACyapB;;ADqFA;EACE,yBA9fwB;AC4a1B;;ADqFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;AClFF;;ADqFA;EACE,yBAzgBkB;ACubpB;;ADsFA;EACE,yBAxgBgB;ACqblB;;ADsFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFF;;ADsFA;;;EAGE,oCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ACwfhB;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ACkgBhB;;ADsFA;EACE,yBAjkBY;AC8ed;;ADsFA;EACE,yBA3jBkB;ACwepB;;ADsFA;EACE,yBA9jBwB;AC2e1B;;ADsFA;EACE,cApkBiB;ACifnB;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFF;;ADuFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ACpFF;;ADuFA;EACE,QAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ACpFF;;ADuFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADuFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ACpFF;;ADuFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACpFF;;ADuFA;;;EAGE,oCAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADyFA;EACE,aAAA;EACA,kBAAA;ACtFF;;ADyFA;EACE,mBAAA;ACtFF;;ADyFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACtFF;;ADyFA;EACE,UAAA;ACtFF;;ADyFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AC0lBpB;;ADyFA;EACE,aAprBkB;AC8lBpB;;ADyFA;EACE,yBAhrBgB;AC0lBlB;;ADyFA;EACE,yBAAA;ACtFF;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;ACylBd;;ADyFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;AC+lBd;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ACqmBd;;ADyFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AC0mBd;;ADyFA;;;EAGE,WAtsBY;ACgnBd;;ADyFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ACsnBd;;ADyFA;EACE,yBA9vBO;ACwqBT;;ADyFA;EACE,eA/tBgB;ACyoBlB;;ADyFA;EACE,YAxtBY;ACkoBd;;ADyFA;;EAEE,sBAAA;ACtFF;;ADyFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC1FF;;AD6FA;EACE,0BAAA;AC1FF;;AD6FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC1FF;;AD6FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC1FF;;AD6FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC1FF;;AD6FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC1FF;;AD6FA;;EAEE,0BAAA;EACA,aAAA;AC1FF;;AD6FA;EACE,kBAAA;EACA,kBAAA;AC1FF;;AD6FA;EACE;IACE,gBAAA;EC1FF;AACF;AD6FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;EC3FF;ED8FA;IACE,uBAAA;IACA,+BAAA;EC5FF;AACF;AD+FA;EACE;;IAAA;AC3FF;ADgGA;EACE;IACE,uBAAA;EC9FF;EDiGA;IACE,6BAAA;EC/FF;AACF;ADkGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGF;EDmGA;;IAEE,kBAAA;ECjGF;EDoGA;IACE,eAAA;EClGF;EDqGA;IACE,aAAA;ECnGF;EDsGA;IACE,8BAAA;IACA,aAAA;ECpGF;AACF;ADuGA;EACE;IACE,iBAAA;ECrGF;EDwGA;IACE,gBAAA;ECtGF;EDyGA;;KAAA;ACrGF;AD0GA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GJ;AD2GI;EAPF;IAQI,gBAAA;ECxGJ;AACF;AD2GE;EACE,WAAA;EACA,cAAA;ACzGJ;AD2GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ACzGN;AD0GM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECvGN;AACF;ADwGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACtGR;AD0GI;EACE,WAAA;EACA,cAAA;ACxGN;ADyGA;EACE,cAAA;ACvGF;ADyGM;EACE,WAAA;EACA,mBAAA;ACvGR;ADyGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACvGV;AD0GQ;EACE,kFAAA;ACxGV;AD6GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC3GR;AD8GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC5GR;AD8GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC5GV;AD+GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AC7GV;;ADoHA,mBAAA;AACA;EACI,2BAAA;ACjHJ;;ADoHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACjHJ;ADmHI;EATF;IAUI,yBAAA;EChHJ;AACF;ADkHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EC/GJ;AACF;ADkHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AChHR;ADoHI;EACE,SAAA;AClHN;ADoHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHR;ADoHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHR;AACF;ADmHQ;EACE,SAAA;EACA,UAAA;ACjHV;ADmHU;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHV;AACF;ADkHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GV;AACF;ADiHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/GZ;ADkHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHZ;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADyHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ACtHJ;ADuHI;EANH;IAOK,uBAAA;ECpHJ;AACF;;ADsHA;EACE,gBAAA;ACnHF;ADqHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACnHJ;ADqHI;EARF;IASI,kBAAA;EClHJ;AACF;ADmHI;EAXF;IAYI,iBAAA;IACA,uBAAA;EChHJ;AACF;ADkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AChHN;ADkHM;EALF;IAMI,4BAAA;EC/GN;AACF;ADkHI;EACE,4BAAA;AChHN;ADoHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AClHJ;ADoHI;EALF;IAMI,uBAAA;ECjHJ;AACF;ADmHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACjHN;ADmHM;EALF;IAMI,4BAAA;EChHN;AACF;ADkHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AChHN;ADiHM;EARF;IASI,eAAA;EC9GN;AACF;;ADqHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;AClHF;ADoHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AClHJ;;AAzlCA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AA4lCJ;AA1lCI;EACI,eAAA;AA4lCR;AAzlCI;EACI,gBAAA;AA2lCR;AAzlCI;EACI,aAAA;EACA,WAAA;EACA,cDqCM;ECpCN,eAAA;AA2lCR;AAxlCI;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDiBc;EChBd,WD0BM;ACgkCd;AAxlCI;EACI,kBAAA;EACA,eAAA;AA0lCR;AAxlCI;EACI,YAAA;EACA,kBAAA;EACA,yBD8BW;EC7BX,iBAAA;EACA,WDeM;ECdN,eAAA;EACA,YAAA;AA0lCR;AAxlCI;EACI,2CDwBa;ECvBb,YAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AA0lCR;;AAtlCA,6BAAA;AACA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,yCAAA;AAylCJ;;AAtlCA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAylCJ;;AAtlCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAylCF;;AAtlCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAylCF;;AAtlCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAylCF;;AAtlCA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,SAAA;AAylCF;;AAtlCA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAylCJ;;AAtlCA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gCAAA;AAylCJ;AAxlCI;EACI,mBAAA;AA0lCR;;AAtlCA;EACI,eAAA;EACA,cAAA;AAylCJ;;AAtlCA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,4EAAA;AAylCJ;AAxlCI;EACI,mBAAA;EACA,qBAAA;EACA,cAAA;AA0lCR;AAxlCI;EACI,0BAAA;EACA,mBAAA;AA0lCR;;AAtlCA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,cAAA;AAylCJ;AAxlCI;EACI,0BAAA;EACA,mBAAA;AA0lCR;AAxlCI;EACI,YAAA;EACA,mBAAA;AA0lCR;;AAtlCA;EACI,mBDxGe;ACisCnB;;AAtlCA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,0BAAA;AAylCJ;;AAtlCA;EACI,2BAAA;AAylCJ","sourcesContent":["/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n\n#addform{\n    width: 100%;\n    border-radius: 5px;\n    margin-top: 30px;\n    padding-bottom: 40px;\n    border-radius: 5px;\n\n    #addheading{\n        font-size: 18px;\n    }\n    \n    .formarea{\n        margin-top: 80px;\n    }\n    .inputbox{\n        padding: 10px;\n        width: 100%;\n        color: $black-color;\n        font-size: 14px;\n    }\n\n    .inputbox1{\n        padding: 6px;\n        border: none;\n        border-radius: 3px;\n        width: 100%;\n        background-color: $darkTheme_darkBlue;\n        color: $white-color;         \n    }\n    .eyeicon{\n        margin-left: -30px;\n        cursor: pointer;\n      }\n    .savebtn{\n        border: none;\n        border-radius: 5px;\n        background-color: $primary-btncolor;\n        padding: 8px 12px;\n        color: $white-color;\n        font-size: 14px;\n        float: unset;\n    }\n    .backbtn{\n        background-color: $secondary-btncolor;\n        color: white;\n        border: none;\n        width: 100px;\n        padding: 5px;\n        border-radius: 5px;\n        margin-bottom: 10px;\n        margin-right: 10px;\n    }\n}\n\n/* Notification preferences */\n.preferencesCard {\n    width: 100%;\n    border-radius: 8px;\n    margin-top: 32px;\n    padding: 24px;\n    background: #fff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.preferencesTitle {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 20px;\n    color: #1f2937;\n}\n\n.preferencesLoading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 80px;\n}\n\n.profileLoadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n}\n\n.suspenseFallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n}\n\n.loading {\n  text-align: center;\n  color: #4b5563;\n  font-size: 16px;\n  font-weight: 400;\n  font-family: 'Lufga', 'Inter', sans-serif;\n  margin: 0;\n}\n\n.preferencesList {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.preferenceRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 0;\n    border-bottom: 1px solid #e5e7eb;\n    &:last-child {\n        border-bottom: none;\n    }\n}\n\n.preferenceLabel {\n    font-size: 14px;\n    color: #374151;\n}\n\n.manageBtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 12px;\n    padding: 10px 22px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #CD47F3;\n    background: #fff;\n    border: 1.5px solid #CD47F3;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease;\n    &:hover {\n        background: #f9f0fe;\n        border-color: #b83ad9;\n        color: #b83ad9;\n    }\n    &:focus-visible {\n        outline: 2px solid #CD47F3;\n        outline-offset: 2px;\n    }\n}\n\n.toggle {\n    position: relative;\n    width: 44px;\n    height: 24px;\n    border-radius: 12px;\n    border: none;\n    background: #d1d5db;\n    cursor: pointer;\n    transition: background 0.2s;\n    flex-shrink: 0;\n    &:focus {\n        outline: 2px solid $primary-btncolor;\n        outline-offset: 2px;\n    }\n    &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n    }\n}\n\n.toggleOn {\n    background: $primary-btncolor;\n}\n\n.toggleThumb {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: #fff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n    transition: transform 0.2s;\n}\n\n.toggleOn .toggleThumb {\n    transform: translateX(20px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `settings_dashboard__FHk5D`,
	"dashboardContain": `settings_dashboardContain__U2OSm`,
	"bodythemedark": `settings_bodythemedark__CUjRX`,
	"cont2": `settings_cont2__VlNwH`,
	"top_header": `settings_top_header__ff-Zj`,
	"top_header_inner": `settings_top_header_inner__CdYKG`,
	"subLink": `settings_subLink__DFs3N`,
	"cst_vendr": `settings_cst_vendr__igBRt`,
	"form-control": `settings_form-control__qWwCC`,
	"footer": `settings_footer__P4xQU`,
	"bodythemelight": `settings_bodythemelight__daVLj`,
	"bodythemeNew": `settings_bodythemeNew__YiMMO`,
	"headerthemelight": `settings_headerthemelight__-DecU`,
	"headerthemedark": `settings_headerthemedark__VXMQL`,
	"menuthemelight": `settings_menuthemelight__xa936`,
	"menuthemedark": `settings_menuthemedark__0RlW9`,
	"menulinklight": `settings_menulinklight__2ukHf`,
	"menulinkdarkSelected": `settings_menulinkdarkSelected__qg5eL`,
	"menulinklightSelected": `settings_menulinklightSelected__-Sh8x`,
	"menulinkdark": `settings_menulinkdark__ZEp0Q`,
	"sub_arrow": `settings_sub_arrow__fGoo-`,
	"headinglight": `settings_headinglight__doSQ0`,
	"headingdark": `settings_headingdark__n+TEX`,
	"searchboxlight": `settings_searchboxlight__Exe8H`,
	"searchboxdark": `settings_searchboxdark__0LYGy`,
	"tableheadlight": `settings_tableheadlight__I2wDM`,
	"tableheaddark": `settings_tableheaddark__BAzcZ`,
	"table": `settings_table__wcs2I`,
	"table-borderless": `settings_table-borderless__XlVcO`,
	"left-section": `settings_left-section__Mo-jA`,
	"tablebodylight": `settings_tablebodylight__F8haX`,
	"tablebodydark": `settings_tablebodydark__qeszF`,
	"paginationlight": `settings_paginationlight__BGULt`,
	"paginationdark": `settings_paginationdark__Hz6pf`,
	"formthemelight": `settings_formthemelight__HnEnB`,
	"formthemedark": `settings_formthemedark__ffb0i`,
	"viewformlight": `settings_viewformlight__AIIgi`,
	"permissionboxlight": `settings_permissionboxlight__UvL2i`,
	"permissionboxdark": `settings_permissionboxdark__qBhr4`,
	"errormsgclr": `settings_errormsgclr__QmeiF`,
	"graphclrlight": `settings_graphclrlight__rlfpD`,
	"graphclrdark": `settings_graphclrdark__tho2P`,
	"card1bglight": `settings_card1bglight__mR3L5`,
	"card1bgdark": `settings_card1bgdark__HX9ph`,
	"card2bglight": `settings_card2bglight__+y-JH`,
	"card2bgdark": `settings_card2bgdark__Kfhe7`,
	"card3bglight": `settings_card3bglight__XbcQO`,
	"card3bgdark": `settings_card3bgdark__ILj6B`,
	"card4bglight": `settings_card4bglight__fGD5L`,
	"card4bgdark": `settings_card4bgdark__0tK9O`,
	"actionbtnlight": `settings_actionbtnlight__4Sk0H`,
	"actionbtndark": `settings_actionbtndark__La-Jh`,
	"profiledropdownlight": `settings_profiledropdownlight__NbgyO`,
	"profiledropdowndark": `settings_profiledropdowndark__D0QpQ`,
	"settingsection": `settings_settingsection__xu5at`,
	"addform": `settings_addform__Dk7Mj`,
	"savebtn": `settings_savebtn__yNpbe`,
	"profile_conatiner": `settings_profile_conatiner__rzq8z`,
	"ag-theme-alpine": `settings_ag-theme-alpine__wCbtM`,
	"ag-row": `settings_ag-row__xu1As`,
	"formbtn": `settings_formbtn__mm3Wt`,
	"resetbtn": `settings_resetbtn__FRARY`,
	"addBtn": `settings_addBtn__eaiUM`,
	"addDltBtn": `settings_addDltBtn__ArGCa`,
	"addbtnlight": `settings_addbtnlight__gWrRV`,
	"addbtndark": `settings_addbtndark__NmlKJ`,
	"cust_addBtn": `settings_cust_addBtn__OhiGl`,
	"deleteBtn": `settings_deleteBtn__bL4Ju`,
	"confirmBtn": `settings_confirmBtn__Wnp0z`,
	"delPopContainer": `settings_delPopContainer__FCjdY`,
	"modal-body": `settings_modal-body__MJgKL`,
	"delet_icon": `settings_delet_icon__uP6T3`,
	"arrowback": `settings_arrowback__qnVSX`,
	"drpdwn_btn": `settings_drpdwn_btn__PsPxB`,
	"empname": `settings_empname__6QldI`,
	"navitemli": `settings_navitemli__4IC51`,
	"tabnavli": `settings_tabnavli__-QWK2`,
	"settingsgeneral": `settings_settingsgeneral__0GBoO`,
	"settingslinks": `settings_settingslinks__vcT1Z`,
	"dropdown_menu_contain": `settings_dropdown_menu_contain__H2iGV`,
	"dropdown_item": `settings_dropdown_item__Ioitd`,
	"profile_arrrow_dwn": `settings_profile_arrrow_dwn__+vDFh`,
	"dateinputbox1": `settings_dateinputbox1__enon-`,
	"modal-content": `settings_modal-content__WgMKL`,
	"larg_model": `settings_larg_model__xIt3W`,
	"modal-dialog": `settings_modal-dialog__6cI4N`,
	"modal-header": `settings_modal-header__qqmqs`,
	"btn-primary": `settings_btn-primary__3ygSu`,
	"form-select": `settings_form-select__qBlVU`,
	"CustomTable_tableheadlight__HuHZw": `settings_CustomTable_tableheadlight__HuHZw__gfJuU`,
	"CustomTable_tableheaddark__nwqb4": `settings_CustomTable_tableheaddark__nwqb4__U+iwe`,
	"sectionright": `settings_sectionright__lAAyc`,
	"exer_modal_contain": `settings_exer_modal_contain__Yk2sS`,
	"active_show_outer": `settings_active_show_outer__R5yTq`,
	"active_show_inner": `settings_active_show_inner__Zj-Pn`,
	"act_box_img": `settings_act_box_img__N4X0j`,
	"act_box_cnt": `settings_act_box_cnt__ihkKs`,
	"act_box_bdg": `settings_act_box_bdg__eX64N`,
	"sold": `settings_sold__X86iS`,
	"timezone_code_pill": `settings_timezone_code_pill__1xsNj`,
	"attent_details_row1": `settings_attent_details_row1__VXHV7`,
	"attent_details": `settings_attent_details__Xkm58`,
	"attent_details_inner": `settings_attent_details_inner__6bnjc`,
	"attent_details_inner_l": `settings_attent_details_inner_l__Z3vcp`,
	"attent_details_inner_r": `settings_attent_details_inner_r__L4iMw`,
	"attent_details_row": `settings_attent_details_row__DTIoo`,
	"attent_details_row_box": `settings_attent_details_row_box__8SFJs`,
	"attent_details_row_last": `settings_attent_details_row_last__PjSGB`,
	"interesting_fact": `settings_interesting_fact__avjXm`,
	"showbox_sec": `settings_showbox_sec__BE8je`,
	"show_box_main": `settings_show_box_main__OAgao`,
	"show_box": `settings_show_box__fMbHW`,
	"no_show_box": `settings_no_show_box__SKKRO`,
	"attent_flex": `settings_attent_flex__DH2zZ`,
	"addheading": `settings_addheading__8sSM1`,
	"formarea": `settings_formarea__QYqBI`,
	"inputbox": `settings_inputbox__7agbd`,
	"inputbox1": `settings_inputbox1__5RkFm`,
	"eyeicon": `settings_eyeicon__dQMCd`,
	"backbtn": `settings_backbtn__O1vJn`,
	"preferencesCard": `settings_preferencesCard__o0f6B`,
	"preferencesTitle": `settings_preferencesTitle__z3tfr`,
	"preferencesLoading": `settings_preferencesLoading__FPBcP`,
	"profileLoadingContainer": `settings_profileLoadingContainer__MUlKI`,
	"suspenseFallback": `settings_suspenseFallback__hze99`,
	"loading": `settings_loading__i+1Zh`,
	"preferencesList": `settings_preferencesList__iGHhx`,
	"preferenceRow": `settings_preferenceRow__ENgJt`,
	"preferenceLabel": `settings_preferenceLabel__69At4`,
	"manageBtn": `settings_manageBtn__60Iwj`,
	"toggle": `settings_toggle__CB5ik`,
	"toggleOn": `settings_toggleOn__8Pi8-`,
	"toggleThumb": `settings_toggleThumb__5HZSd`
};
export default ___CSS_LOADER_EXPORT___;
